// Wall settings panel for map editor

import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';

/**
 * Wall settings panel component
 * Allows editing wall properties in the map editor
 */
class WallSettingsPanel extends BaseComponent {
  static properties = {
    wall: { type: Object },
  };

  static styles = css`
    :host {
      display: block;
    }

    .wall-settings-panel {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(0, 0, 0, 0.9);
      border: 1px solid #555;
      border-radius: 8px;
      padding: 16px;
      z-index: 1000;
      min-width: 250px;
      color: #fff;
    }

    .panel-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
    }

    .panel-header h3 {
      margin: 0;
      font-size: 16px;
      font-weight: bold;
    }

    .dismiss-button {
      background: none;
      border: none;
      color: #fff;
      font-size: 24px;
      line-height: 1;
      cursor: pointer;
      padding: 0;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      transition: background-color 0.2s;
    }

    .dismiss-button:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    .setting-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
    }

    .setting-row:last-child {
      margin-bottom: 0;
    }

    .setting-row label {
      font-size: 14px;
      margin-right: 12px;
    }

    .setting-row input[type='checkbox'] {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  `;

  constructor() {
    super();
    /** @type {import('../../types/jsdoc-types.js').Wall|null} */
    this.wall = null;
  }

  _handleToggleBlocksVision() {
    this.dispatchEvent(new CustomEvent('toggle-blocks-vision', { bubbles: true }));
  }

  _handleDismiss() {
    this.dispatchEvent(new CustomEvent('dismiss', { bubbles: true }));
  }

  render() {
    if (!this.wall) {
      return html``;
    }

    return html`
      <div class="wall-settings-panel">
        <div class="panel-header">
          <h3>Wall Settings</h3>
          <button class="dismiss-button" title="Close" @click="${this._handleDismiss}">×</button>
        </div>
        <div class="setting-row">
          <label for="blocks-vision">Blocks Vision:</label>
          <input
            id="blocks-vision"
            type="checkbox"
            .checked="${this.wall.blocksVision}"
            @change="${this._handleToggleBlocksVision}"
          />
        </div>
      </div>
    `;
  }
}

customElements.define('wall-settings-panel', WallSettingsPanel);
